import AbstractBuilder from "@/modules/reader/annotations/builders/AbstractBuilder";
import PlaySpanAnnotation from "@/modules/reader/annotations/builders/karaoke/PlaySpanAnnotation";

class PlaySpanBuilder {

    constructor() {

    }

    static get Builder() {
        class Builder extends AbstractBuilder {

            setBookPath(bookPath) {
                this.bookPath = bookPath;
                return this;
            }

            setAvailableSpeech(availableSpeech) {
                this.availableSpeech = availableSpeech;
                return this;
            }

            build() {
                return new PlaySpanAnnotation(this);
            }
        }
        return Builder;
    }
}

export default PlaySpanBuilder